
import React from 'react'
import axiosInstance from '../../config';


// async funtion for make smoother and faster without waiting of acknowledgement
export const  newPasswordService= async({code, password})=> {
    try {
    const response = await axiosInstance.post(
      '/v1/reset-password',
      { code, password }, 
      {
        headers: {
          'Content-Type': 'application/json', 
        },
      }
    );

    return {
      success: true,//return success true or false
      data: response.data,//return data

      status:response.status
    };
  } catch (error) {
   
    return {
      success: false,
      message: error.response?.data?.data || "Reset failed",
      status: error.response?.status || 500,
    };
  }
  
 
};